import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import firebase from "firebase/compat/app";
import { Element, scroller } from "react-scroll";

const Chapter2_2 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Warum gilt der Mensch als eine der größten Schwachstellen in der Cybersecurity?",
      options: [
        {
          value: "A",
          label:
            "Weil technische Sicherheitsmaßnahmen immer fehlerfrei sind und nur menschliche Fehler zu Angriffen führen. ",
        },
        {
          value: "B",
          label:
            "Weil Angreifer oft menschliches Verhalten wie mangelndes Bewusstsein oder Nachlässigkeit ausnutzen, um Zugang zu sensiblen Daten zu erhalten.",
        },
      ],
      correct: "B",
    },
    {
      question:
        "Frage 2: Welche Aussage zur Rolle des Menschen in der Cybersecurity ist korrekt?",
      options: [
        {
          value: "A",
          label:
            "Menschen sind immer und ausschließlich eine Schwachstelle in der IT-Sicherheit. Sie sollten möglichst wenig mit sensiblen Systemen interagieren.",
        },
        {
          value: "B",
          label:
            "Menschen können sowohl eine Schwachstelle als auch eine effektive erste Verteidigungslinie gegen Cyberbedrohungen sein, abhängig von ihrer Schulung und ihrem Bewusstsein.",
        },
      ],
      correct: "B",
    },
  ];
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);
  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 2_2.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "2_2",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("2_2"),
            });
          console.log("Dokument aktualisiert mit Kapitel 2_2.");
        } else {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "2_2",
              completedChapters: ["2_2"],
            });
          console.log("Dokument erstellt mit Kapitel 2_2.");
        }

        navigate("/cybersecurity/2_3"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  2. Sicherheitslücken und Schwachstellen
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Der Mensch als Schwachstelle
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="px-5 pt-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">
            Kapitel 2: Sicherheitslücken und Schwachstellen
          </h3>
          <h2 className="text-center p-3">Der Mensch als Schwachstelle</h2>
          <img
            src="/images/menschlichefehler.webp"
            alt="Menschliche Fehler"
            style={{ position: "relative", maxWidth: "40%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h2 className="p-5">Warum ist der Mensch eine Schwachstelle?</h2>
          <p className="col-lg-11 mx-auto">
            Der Mensch wird oft als die größte Schwachstelle in der
            Cybersecurity bezeichnet, weil menschliches Verhalten, Fehler und
            Entscheidungen häufig Sicherheitsmaßnahmen untergraben. Selbst mit
            der besten Technologie und den stärksten Sicherheitsprotokollen
            bleibt der menschliche Faktor ein nicht zu unterschätzendes Risiko.
            Es gibt mehrere Gründe, warum der Mensch als Schwachstelle gilt:
          </p>
          <h4 className="p-5">
            Viele Sicherheitsvorfälle entstehen durch unbeabsichtigte
            menschliche Fehler:
          </h4>
          <p className="col-lg-11 text-start mx-auto">
            {" "}
            <ul>
              <li>
                <strong>Nachlässigkeit: </strong>Einfache Versehen wie das
                Versenden vertraulicher Informationen an falsche Empfänger oder
                das Vergessen, den Computer zu sperren, können erhebliche Folgen
                haben.
              </li>{" "}
              <br />
              <li>
                {" "}
                <strong>Mangelndes Sicherheitsbewusstsein: </strong>Viele
                Mitarbeiter sind sich der Risiken bestimmter Handlungen nicht
                bewusst. Hierzu zählen z. B. das Öffnen verdächtiger
                E-Mail-Anhänge oder die Verwendung unsicherer öffentlicher
                WLAN-Netze.
              </li>{" "}
              <br />
              <li>
                {" "}
                <strong>Überforderung: </strong>In stressigen Situationen oder
                bei Überlastung steigt die Wahrscheinlichkeit von Fehlern, die
                wiederum zu Sicherheitsverletzungen führen können.
              </li>{" "}
              <br />
              <li>
                {" "}
                <strong>Technische Unwissenheit: </strong>Mangelndes Verständnis
                für Technologie kann zu unbeabsichtigten Sicherheitsverletzungen
                führen, z. B. durch falsche Konfiguration von
                Sicherheitseinstellungen.
              </li>
            </ul>
          </p>

          <p className="col-lg-11 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            68% der Sicherheitsverletzungen sind auf menschliches Versagen
            zurückzuführen. (Verizon Data Breach Investigations Report 2024)
          </p>
        </div>
      </div>

      <div className="gelb-section">
        <div className="container pb-5">
          <div className="p-5 text-center">
            <h2 className="p-5">Bewusste Verstöße</h2>
            <p className="col-lg-11 mx-auto">
              Nicht alle durch menschliche Fehler entstandenen Schwachstellen
              sind unbeabsichtigt. Einige entstehen durch bewusste
              Entscheidungen:
              <br />
              <br />
              <strong>Bequemlichkeit: </strong>Mitarbeiter umgehen oft
              Sicherheitsmaßnahmen, die sie als nervig empfinden, z. B. durch
              die Verwendung schwacher, leicht zu merkender Passwörter.
              <br />
              <br /> <strong>Produktivitätsdruck: </strong>In dem Wunsch,
              Aufgaben schnell zu erledigen, werden Sicherheitsrichtlinien
              manchmal bewusst ignoriert.
              <br />
              <br /> <strong>Überheblichkeit: </strong>Einige Benutzer glauben
              fälschlicherweise, dass sie immun gegen Cyberangriffe sind und
              ignorieren daher Sicherheitsprotokolle. <br />
              <br />
              <strong>Insider-Bedrohungen: </strong>In seltenen Fällen können
              Mitarbeiter als{" "}
              <Link to="/cybersecurity/1_5#insider" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Insider
              </Link>{" "}
              absichtlich Sicherheitsverletzungen begehen, sei es aus Rache,
              finanziellem Gewinn oder anderen Motiven.
            </p>

            <p className="col-lg-11 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Bei Morgan Stanley hatte 2015 ein Finanzberater aufgrund von
              Arbeitsdruck und dem Wunsch, Kundenanfragen schnell zu bearbeiten,
              sensible Kundendaten auf einem ungesicherten privaten Datenträger
              abgespeichert, um von zu Hause aus nach der Arbeit weiterarbeiten
              zu können. Diese Daten umfassten Namen, Kontonummern und
              Anlageinformationen von etwa 350.000 Kunden. Obwohl dies gegen die
              Sicherheitsrichtlinien der Bank verstieß, entschied der
              Mitarbeiter, die Daten auf diese Weise zu speichern, um seine
              Arbeit schneller erledigen zu können. Der Datenträger wurde später
              gestohlen, wodurch die sensiblen Informationen in falsche Hände
              gelangten. Morgan Stanley musste eine erhebliche Geldstrafe
              zahlen, da der Vorfall als Missachtung von Sicherheitsvorgaben
              gewertet wurde.
            </p>
          </div>
        </div>
        <div className="grey-section">
          <div className="container pb-5">
            <div className="p-5 text-center">
              <h2 className="p-5">Soziale und psychologische Faktoren</h2>

              <p className="col-lg-11 mx-auto">
                Menschliches Verhalten wird stark von sozialen und
                psychologischen Faktoren beeinflusst:
                <br />
                <br />
                <strong>Vertrauen: </strong>Menschen neigen dazu, anderen zu
                vertrauen, was von Angreifern ausgenutzt werden kann,
                insbesondere bei Social Engineering-Angriffen.
                <br />
                <br /> <strong>Autoritätshörigkeit: </strong>Die Tendenz,
                Anweisungen von vermeintlichen Autoritätspersonen zu befolgen,
                kann in Phishing-Szenarien ausgenutzt werden.
                <br />
                <br /> <strong>Gruppendynamik: </strong>Das Verhalten von
                Kollegen kann einen starken Einfluss auf die Einhaltung von
                Sicherheitsrichtlinien haben. <br />
                <br />
                <strong>Fehlendes Verantwortungsgefühl: </strong>Wenn
                Mitarbeiter glauben, dass Cybersecurity nicht in ihren
                Zuständigkeitsbereich fällt, sind sie weniger wachsam.
              </p>
              <p className="col-lg-11 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
                <img
                  src="/images/attack.svg"
                  alt="Angriff"
                  style={{
                    position: "relative",
                    maxWidth: "10%",
                    height: "auto",
                  }}
                />
                Ein bekanntes Beispiel für das Ausnutzen von sozialem Verhalten
                und Neugier ist der Fall des RSA Security Hacks (eine Firma, die
                sich selbst auf Security-Maßnahmen spezialisiert hat) im Jahr
                2011. Bei diesem Angriff verschickten die Hacker gezielt E-Mails
                an Mitarbeiter von RSA. Diese E-Mails enthielten den Betreff
                „2011 Recruitment Plan“ – etwas, das für viele Mitarbeiter auf
                den ersten Blick wie eine interne Mitteilung aussah. Die E-Mail
                enthielt eine Excel-Datei mit einem schädlichen Anhang. Als ein
                neugieriger Mitarbeiter diese Datei öffnete, wurde eine
                Schwachstelle im Adobe Flash Player ausgenutzt, die den
                Angreifern Zugriff auf das Netzwerk ermöglichte.
              </p>
            </div>
          </div>
        </div>

        <div className="white-section">
          <div className="container pb-5">
            <div className="p-5 text-center">
              <h2 className="p-5">Human Risk Management</h2>
              <p className="col-lg-11 mx-auto">
                Es gibt wirklich kaum noch jemanden, der noch nie einen Spam
                oder eine Fake-Mail erhalten und als solche erkannt hat.
                Trotzdem bleibt der Mensch immer noch eine der größten
                Schwachstellen in der Cybersecurity. Wie kann das sein? <br />
                <br /> Durch die sich rasant entwickelnde Technologie und
                potenziert durch den Einsatz von KI, wird es immer schwieriger,
                mit den neuesten Sicherheitsbedrohungen Schritt zu halten. Dass
                man nicht auf einen Link klickt, der mit falscher
                Rechtschreibung einen Millionengewinn verspricht, sollte
                inzwischen jeder wissen. Aber wie reagiert man, wenn man eine
                Sprachnachricht erhält, in der die durch Deepfake perfekt
                gefälschten Stimme einer Führungsperson, die darum bittet, die
                Daten XY zu senden? <br />
                <br />
                Bei aller Begeisterung für neue Technologien braucht es auch
                eine große Wachsamkeit und Sensibilisierung für Risiken. Genau
                hier setzt das <strong> Human Risk Management (HRM)</strong> an.
                Ein innovativer Ansatz, der den Menschen als zentrale Komponente
                der Sicherheitsstrategie betrachtet.
                <br />
                <br />
                Human Risk Management (HRM) beschreibt die gezielte
                Identifikation, Analyse und Reduzierung von Sicherheitsrisiken,
                die durch menschliches Verhalten entstehen. Anders als
                herkömmliche Sicherheitsprogramme, die vor allem technische
                Lösungen in den Vordergrund stellen, zielt HRM darauf ab, das
                Bewusstsein und Verhalten von Mitarbeitern zu stärken. Dabei
                geht es nicht darum, Menschen als Problem zu betrachten, sondern
                sie zu einem aktiven Teil der Sicherheitsstrategie zu machen.
              </p>
              <h4 className="p-5">Die Bausteine des Human Risk Management:</h4>
              <p className="col-lg-11 mx-auto">
                <strong>Bewusstseinsbildung (Security Awareness): </strong> Ein
                gut informierter Mitarbeiter ist die beste Verteidigung.
                Regelmäßige Schulungen, Simulationen von Cyberangriffen (z. B.
                Phishing-Tests) und interaktive Workshops helfen, potenzielle
                Bedrohungen zu erkennen und richtig darauf zu reagieren.
                <br />
                <br />
                <strong>Verhaltensanalyse: </strong> Durch die Analyse des
                Sicherheitsverhaltens der Mitarbeiter können Unternehmen gezielt
                Schwachstellen identifizieren. Tools und Technologien
                unterstützen dabei, Risiken frühzeitig zu erkennen, ohne die
                Privatsphäre der Mitarbeiter zu verletzen.
                <br />
                <br />
                <strong>Förderung einer Sicherheitskultur: </strong>
                Sicherheitsbewusstsein muss Teil der Unternehmenskultur werden.
                Mitarbeiter sollten nicht nur über Sicherheitsrisiken informiert
                sein, sondern sich auch motiviert fühlen, aktiv zur Sicherheit
                beizutragen.
              </p>
              <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                <img
                  src="/images/fact.svg"
                  alt="Transparent"
                  style={{
                    position: "relative",
                    maxWidth: "8%",
                    height: "auto",
                  }}
                />
                CybSafe fand heraus, dass jeder investierte Dollar in Schulung
                und Sensibilisierung durchschnittlich 2,90 Dollar an
                eingesparten Kosten für Sicherheitsvorfälle einbringt.
                Schulungen zählen also zu den effektivsten Maßnahmen, um die
                Sicherheitslage zu verbessern und potenzielle Angriffe zu
                verhindern.
              </p>
            </div>
          </div>

          <div className="container">
            <div
              className="safe rounded-2 text-center"
              style={{ backgroundColor: "#fec748" }}
            >
              <img
                src="/images/abwehr.svg"
                alt="Abwehr"
                style={{
                  position: "relative",
                  maxWidth: "7%",
                  height: "auto",
                }}
              />
              <Element name="saw">
                <h3 className="p-5">Lösungsansätze</h3>
                <p className="col-lg-10 text-start mx-auto">
                  <ul>
                    <li>
                      Regelmäßige, interaktive Schulungen können das
                      Sicherheitsbewusstsein{" "}
                      <strong>(Security Awareness) </strong> der Mitarbeiter
                      schärfen.
                    </li>
                    <br />

                    <li>
                      Die Entwicklung einer <strong>Sicherheitskultur </strong>{" "}
                      im Unternehmen, die Sicherheit als gemeinsame
                      Verantwortung betrachtet, ist entscheidend.
                    </li>

                    <br />
                    <li>
                      Sicherheitsmaßnahmen sollten so{" "}
                      <strong>benutzerfreundlich </strong> gestaltet sein, dass
                      sie die Produktivität nicht behindern und leicht zu
                      befolgen sind.
                      <br />
                    </li>
                    <li>
                      <strong>Klare Sicherheitsrichtlinien </strong> und
                      transparente Konsequenzen bei Verstößen können helfen,
                      bewusste Verstöße zu reduzieren.
                    </li>
                    <br />

                    <li>
                      Der Einsatz von Technologien wie{" "}
                      <strong>automatisierte Sicherheitsüberprüfungen </strong>{" "}
                      oder KI-gestützte Anomalieerkennung kann menschliche
                      Fehler minimieren.
                    </li>

                    <br />
                    <li>
                      Das psychologische Verständnis und die{" "}
                      <strong>
                        Berücksichtigung menschlicher Verhaltensweisen{" "}
                      </strong>{" "}
                      bei der Gestaltung von Sicherheitsmaßnahmen können deren
                      Wirksamkeit erhöhen.{" "}
                    </li>
                  </ul>
                </p>
              </Element>
              <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                <img
                  src="/images/fact.svg"
                  alt="Transparent"
                  style={{
                    position: "relative",
                    maxWidth: "8%",
                    height: "auto",
                  }}
                />
                Der Mensch kann nicht nur eine Schwachstelle, sondern auch eine
                entscheidende Stärke in der Cybersecurity sein. Gut informierte
                und engagierte Mitarbeiter können eine effektive erste
                Verteidigungslinie gegen Cyberbedrohungen bilden. Die
                Herausforderung besteht darin, dieses Potenzial zu nutzen und
                gleichzeitig die Risiken zu minimieren.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Fragenteil */}
      <div className="container pt-5 my-5">
        <div className="text-center m-4">
          <h2>Überprüfe dein Wissen</h2>
          <p className="col-lg-11 mx-auto">
            Mit den richtigen Antworten kommst du weiter!
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-11 text-start">
            <form onSubmit={handleSubmit}>
              {questions.map((question, index) => (
                <div key={index} className="mb-4">
                  <p className="fs-4">{question.question}</p>{" "}
                  {question.options.map((option) => (
                    <div key={option.value} className="form-check">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name={`question${index}`}
                        value={option.value}
                        checked={selectedAnswers[index] === option.value}
                        onChange={() => handleAnswerChange(index, option.value)}
                      />
                      <label className="form-check-label fs-5">
                        {option.label}
                      </label>{" "}
                    </div>
                  ))}
                </div>
              ))}
              {error && <p className="text-danger">{error}</p>}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  überprüfen
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter2_2;
